var map = {
	"./arrow-left-light.svg": [
		71117,
		117
	],
	"./arrow-left.svg": [
		52518,
		518
	],
	"./arrow-right-light.svg": [
		94060,
		60
	],
	"./arrow-right.svg": [
		66599,
		599
	],
	"./changes-society.svg": [
		45655,
		655
	],
	"./chevron-down.svg": [
		65571,
		571
	],
	"./chevron-left.svg": [
		21192,
		192
	],
	"./chevron-up.svg": [
		32752,
		752
	],
	"./close.svg": [
		91301,
		301
	],
	"./creates-culture.svg": [
		63603,
		603
	],
	"./download.svg": [
		24990,
		609
	],
	"./error.svg": [
		12991,
		991
	],
	"./fullscreen-off.svg": [
		11658,
		658
	],
	"./fullscreen-on.svg": [
		65030,
		30
	],
	"./invents-the-future.svg": [
		8406,
		406
	],
	"./language.svg": [
		98627,
		627
	],
	"./link.svg": [
		37001,
		1
	],
	"./logo-name.svg": [
		60838,
		838
	],
	"./logo.svg": [
		86896,
		896
	],
	"./minus.svg": [
		29297,
		297
	],
	"./plus.svg": [
		43897,
		897
	],
	"./search.svg": [
		6757,
		757
	],
	"./sound-off.svg": [
		22588,
		588
	],
	"./sound-on.svg": [
		39984,
		984
	],
	"./upload.svg": [
		5258,
		258
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 22349;
module.exports = webpackAsyncContext;